import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetCaseDetailById = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseDetail?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseDetailByCaseNumber = async (caseNumber) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseDetailByCaseNumber?caseNumber=${caseNumber}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

// export const GetDownloadCaseAttachment = async (versionData) => {    
//     var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/DownaloadAttachments?url=${versionData}`, CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }

export const GetCaseCommentByCaseId = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseComments?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseHistoryByCaseId = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseHistory?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetAttachmentsByCaseId = async (caseId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseAttachments?caseId=${caseId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CreateCase = async (caseData) => {
    //debugger;
    //console.log(JSON.stringify(caseData))
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Case/CreateCase`, JSON.stringify(caseData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateCase = async (caseData) => {
    //debugger;
    //console.log(caseData)
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Case/UpdateCase`, JSON.stringify(caseData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const CaseList_Filter = async (data) => {

    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Case/FilterCase`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalFilterCaseData = async (searchData) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetUniversalFilterCaseData?searchdata=${searchData}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseRecordTypeList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + 'Case/GetCaseRecordTypeList', CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCallTypeList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + 'Case/GetCallTypeList', CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCountryDetailList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + 'Case/GetCountryMasterList', CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseOriginList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + 'Case/GetCaseOriginList', CommonVariables.API_HEADER)).then(response => response);
    return result;
}
export const GetCaseSRTypeList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + 'Case/GetCaseSRTypeList', CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const GetCallCategoryMappingList = async (callTypeId,recordTypeId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseCategoryMappingList?callTypeId=${callTypeId}&recordTypeId=${recordTypeId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseStageDetailsList = async (callCategoryId,recordTypeId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseStageMappingList?caseCategoryId=${callCategoryId}&recordTypeId=${recordTypeId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseSRTypeDetailsList = async (callCategoryId,recordTypeId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseSRTypeMappingList?caseCategoryId=${callCategoryId}&recordTypeId=${recordTypeId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseSRSubTypeDetailsList = async (caseSRTypeId,recordTypeId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseSRSubTypeMappingList?caseSRTypeId=${caseSRTypeId}&recordTypeId=${recordTypeId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetCaseLocationDetailsList = async (callCategoryId,recordTypeId) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetCaseLocationMappingList?caseCategoryId=${callCategoryId}&recordTypeId=${recordTypeId}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UploadCaseFileAttachment = async (formData) => {

    const response = await trackPromise(axios.post(CommonVariables.API_DOMAIN + 'Case/UploadImages',
         formData, {
            headers: {
                ...CommonVariables.API_HEADER, 
                'Content-Type': 'multipart/form-data' // Ensure it's multipart
            }
        }))
        .then(response => response);
    return response;

}

export const GetActivePaymentModeList = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Case/GetActivePaymentModeList`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPatientVisitDataList = async (search) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetPatientVistList?search=${search}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}
